import React from "react";
import {Switch, Route} from 'react-router-dom';

// components
import ListCustomers from "./ListCustomers";
import CustomerDetails from "./CustomerDetails";

class Customers extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path={this.props.match.path} render={(props) => <ListCustomers {...props}/>} />
        <Route path={`${this.props.match.path}/:customerId`}  render={(props) => <CustomerDetails {...props}/>} />
      </Switch>
    );
  }
}

export default Customers;